


export const headerItemData = [
    {
        id: 1,
        title: "Home",
        link: "",
    },
    {
        id: 2,
        title: "Features",
        link: "",
    },
    {
        id: 3,
        title: "Swahili Sentiment",
        link: "https://sentiment.all.tz/",
    },
    {
        id: 4,
        title: "MsaadaAI",
        link: "https://msaadaai.all.tz/",
    }
];